//the below code is for production
import React, { useState, useRef, useEffect } from "react";
import logo from "../logo.png";
import { ImSwitch } from "react-icons/im";
import { Tooltip } from "react-tooltip";
import FileUploadComponent from "./NewUploadFile";
import { useMsal } from "@azure/msal-react";
// import { NavLink } from "react-router-dom";

const Header = () => {
  const { instance } = useMsal();
  const account = instance.getActiveAccount();

  const [showUpload, setShowUpload] = useState(false);
  const wrapperRef = useRef(null);

  const handleLogout = () => {
    instance.logoutRedirect().catch((e) => {
      console.error("Logout failed:", e);
    });
  };

  // Close dropdown on outside click
  useEffect(() => {
    const onDown = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setShowUpload(false);
      }
    };
    document.addEventListener("mousedown", onDown);
    return () => document.removeEventListener("mousedown", onDown);
  }, []);

  // Allowed users
  const allowedUsers = [ "sauravde@wwfindia.net","expensetracker@wwfindia.net"];
  const isAllowedUser = account && allowedUsers.includes(account.username);

      // const buttonClasses = ({ isActive }) =>
      //   `text-white text-lg font-semibold px-4 py-2 rounded-full transition-all duration-300 no-underline
      //    ${isActive ? 'bg-gray-700 text-cyan-400' : 'hover:bg-gray-800'}`;

  return (
    <header className="fixed top-0 left-0 w-full h-[70px] bg-black z-50 shadow-md">
  <div className="h-full max-w-[1400px] mx-auto px-4">
    <div className="flex items-center justify-between w-full">
          {/* Left: Logo + User */}
          <div className="flex items-center space-x-4">
            <img src={logo} alt="Logo" className= "w-20 object-contain" />
            <label className="font-bold text-white mb-3">
              Welcome <strong>{account?.name}</strong> !
            </label>
          </div>

          {/* Right: Upload (only for allowed users) + Logout */}
          <div
            className="flex items-center space-x-6 mb-3 relative overflow-visible"
            ref={wrapperRef}
          >
            {/* <nav className="flex items-center space-x-4">
                            
                            
                            {isAllowedUser && (
                                <NavLink to="/" className={buttonClasses}>
                                    Form Page
                                </NavLink>
                            )}

                           
                            {isAllowedUser && (
                                <NavLink to="/report" className={buttonClasses}>
                                    Report
                                </NavLink>
                            )}
                              
                        </nav> */}

            {isAllowedUser && (
              <>
              
                {/* Upload Button */}
                <button
                  onClick={() => setShowUpload((s) => !s)}
                  className="text-white font-semibold bg-gray-700 px-4 py-2 rounded-lg hover:bg-gray-600"
                >
                  Upload File
                </button>

                {/* Dropdown */}
                {showUpload && (
                  <div className="absolute right-0 top-full mt-2 z-50">
                    <div className="bg-white shadow-2xl rounded-xl p-4 w-[22rem] max-w-[90vw]">
                      <FileUploadComponent />
                    </div>
                  </div>
                )}
              </>
            )}

            {/* Logout */}
            <ImSwitch
              className="text-white text-xl cursor-pointer"
              data-tooltip-id="logout-tooltip"
              onClick={handleLogout}
            />
            <Tooltip id="logout-tooltip" place="bottom" content="Logout" />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;

